interface Props {
  src: string
}
export const SoundNotification = ({src}: Props) => {
  return <audio id='audio' src={src}></audio>
}
